import React, { Component, PropTypes } from 'react';

export default class Icon extends Component {
  static propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
    viewPortSize: PropTypes.number
  };

  static defaultProps = {
    color: '#FFFFFF',
    size: 24,
    viewPortSize: 16
  };

  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Icon.js